/** @format */

import React from "react"
import { LoadingProgressBarProps } from "./ToastProgressBar.types"

import { Container, Filler } from "./ToastProgressBar.styled"

const ToastProgressBar = ({ kind, progression }: LoadingProgressBarProps) => {
	return (
		<Container data-testid="toast-progressbar">
			<Filler kind={kind} progression={progression} />
		</Container>
	)
}

export default ToastProgressBar
